<div class="page-loader" *ngIf="!pageStatus">
  <img src="assets/img/spinner.svg"/>
</div>
